require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-ملفات-الصوت.json") })
        }
      }, "path---tags-ملفات-الصوت");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-ملفات-الصوت!./.cache/json/tags-ملفات-الصوت.json
// module id = 619
// module chunks = 231608221292675